import { useEffect } from "react";
import { useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { ToastContainer, toast } from "react-toastify";
import { Grid2 as Grid } from "@mui/material";
import { getNotification, notificationCodes } from "../../modules/notification";
import { getMessageString } from "../../utility";

export const Notification = injectIntl(({ intl }) => {
  const notificationInStore = useSelector(getNotification);

  const accessibilityFix = () => {
    setTimeout(() => {
      const toastsBody = document.getElementsByClassName("Toastify__toast-body");
      if (toastsBody.length > 0) {
        for (let i = 0; i < toastsBody.length; i++) {
          toastsBody[i].removeAttribute("role");
        }
      }
    }, [100]);
  };

  const NotificationContent = () =>
    notificationInStore.message != null && notificationInStore.description != null ? (
      <Grid container spacing={1}>
        <Grid size={12} sx={{ fontWeight: 600 }}>
          {getMessageString(intl, notificationInStore.message, notificationInStore.params)}
        </Grid>
        <Grid size={12} sx={{ fontSize: "0.8em" }}>
          {getMessageString(intl, notificationInStore.description, notificationInStore.params)}
        </Grid>
      </Grid>
    ) : (
      getMessageString(intl, notificationInStore.message, notificationInStore.params)
    );

  useEffect(() => {
    if (notificationInStore)
      toast(<NotificationContent />, {
        onOpen: accessibilityFix(),
        position: "top-right",
        theme: "colored",
        autoClose: notificationInStore.duration != null ? notificationInStore.duration : false,
        type: notificationInStore.type != null ? notificationInStore.type : notificationCodes.INFO,
      });
    else toast.dismiss();
    // eslint-disable-next-line
  }, [notificationInStore]);

  return <ToastContainer />;
});
